<template>
    <div id="hover-panel" v-if="hoveredMarker">
        {{ hoveredMarker.name }}: {{ this.hoveredTxValue }}
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import statFun from '../api/txc'

export default {
  name: 'HoverPanel',

  data: () => {
    return {
      hoveredTxValue: ''
    }
  },

  computed: {
    ...mapGetters({
      queryOrganMode: 'queryOrganMode',
      queryRegionMode: 'queryRegionMode',
      queryYear: 'queryYear',
      selectedStatistic: 'selectedStatistic',

      hoveredMarker: 'hoveredMarker',
      txRecords: 'txRecords'
    }),
    hoveredTx: function () {
      if (!this.hoveredMarker) {
        return null
      }
      for (let i = 0; i < this.txRecords.length; i++) {
        if (this.txRecords[i].tx_ctr_id === this.hoveredMarker.tx_ctr_id) {
          return this.txRecords[i]
        }
      }
    }
  },

  methods: {
    hidePanel: function () {
      this.$store.commit('hoveredMarker', null)
    }
  },

  watch: {
    hoveredTx: function () {
      let query = {
        organMode: this.queryOrganMode,
        regionMode: this.queryRegionMode,
        year: this.queryYear
      }
      let data = statFun['tx_stat_' + this.selectedStatistic.value](this.txRecords, query, this.hoveredTx.tx_ctr_id)
      let yearIndex = data.years.indexOf(this.queryYear)
      this.hoveredTxValue = isNaN(data.hist[yearIndex]) ? 'n/a' : Math.round(100 * data.hist[yearIndex]) + '%'
    }
  }
}
</script>

<style>
#hover-panel {
    background-color: #25826a;
    color: #fff;
    position: absolute;
    padding: 6px;
    top: 50px;
    left: 0;
    z-index: 900;
}
</style>



// WEBPACK FOOTER //
// src/components/HoverPanel.vue